module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"others":"他","top5":"捕獲上位5種"},"en":{"others":"Others","top5":"Top 5 Species"}}')
  delete Component.options._Ctor
}
